export const crmData = {
  clients: [
    {
      id: "c1",
      name: "TechCorp AS",
      industry: "Teknologi",
      contact: "Morten Hansen",
      email: "morten@techcorp.no",
      status: "Aktiv",
      projectsCount: 3,
      lastActivity: "2 dager siden",
      healthScore: 68
    },
    {
      id: "c2",
      name: "Nordic Retail",
      industry: "Varehandel",
      contact: "Linda Berg",
      email: "linda@nretail.se",
      status: "Oppfølging",
      projectsCount: 1,
      lastActivity: "5 timer siden",
      healthScore: 42
    },
    {
      id: "c3",
      name: "Oslo Kommune",
      industry: "Offentlig",
      contact: "Jan Johansen",
      email: "jan.johansen@oslo.kommune.no",
      status: "Aktiv",
      projectsCount: 5,
      lastActivity: "1 uke siden",
      healthScore: 75
    },
    {
      id: "c4",
      name: "FinansHuset",
      industry: "Finans",
      contact: "Sarah Lund",
      email: "sarah@finans.no",
      status: "Planlegging",
      projectsCount: 2,
      lastActivity: "I går",
      healthScore: 82
    }
  ],
  projects: [
    {
      id: "p1",
      clientId: "c1",
      name: "Arbeidsmiljøkartlegging 2024",
      type: "Kartlegging",
      status: "Pågår",
      progress: 65,
      deadline: "20. Jun",
      assessments: { total: 150, completed: 98 }
    },
    {
      id: "p2",
      clientId: "c2",
      name: "Konfliktmekling Avd. Salg",
      type: "Konflikt",
      status: "Kritisk",
      progress: 30,
      deadline: "15. Mai",
      assessments: { total: 12, completed: 12 }
    },
    {
      id: "p3",
      clientId: "c3",
      name: "Lederstøtte Program",
      type: "Coaching",
      status: "Planlagt",
      progress: 0,
      deadline: "01. Aug",
      workshops: 4
    }
  ]
};